import React from 'react';
import { Icon } from '@ontruck/orc';
import styles from '../style.module.scss';
import tel from 'utils/phone';
import Button from '@ontruck/ontruck-react-components/lib/Button';

const Phone = ({ rowData }) => {
  return (
    <div className={styles.onlyHover}>
      <div>
        {rowData.carrier && rowData.carrier.phone ? (
          <Button
            link
            className={styles.phoneButton}
            href={tel(rowData.carrier.phone)}
            onClick={(e) => e.stopPropagation()}
          >
            <Icon size="1.7rem" glyph="phone" color="white" />
          </Button>
        ) : null}
      </div>
    </div>
  );
};
export default Phone;
